export default __webpack_public_path__ + "i18n/translations/translation-he.c3ae2f4d.json";